var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-confirm-dialog',{attrs:{"title":"Delete Tag?","button-type":"danger","button-text":"Delete Tag","show":_vm.shouldShow},on:{"update:show":function($event){_vm.shouldShow=$event},"confirm":_vm.deleteTag}},[_c('p',[_vm._v(" If you delete this tag, all data associated with it will be permanently erased, This action cannot be undone. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }